import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { IPayConfig } from 'src/app/shared/models/payment.model';
import { PaymentService, ScriptLoaderService } from 'src/app/shared/services';

declare const Stripe: any;

@Component({
  selector: 'app-stripe-express',
  standalone: true,
  imports: [],
  templateUrl: './stripe-express.component.html',
  styleUrls: ['./stripe-express.component.scss']
})
export class StripeExpressComponent {

  readonly payments = inject(PaymentService);
  readonly scriptLoader = inject(ScriptLoaderService);

  @Input() currency: string = 'usd';
  @Input() amount: number = 100; // amount * 100 convert in cents or paise
  @Output() availablePaymentMethods = new EventEmitter();
  @Output() onCheckoutClick = new EventEmitter();
  @ViewChild('stripeBtnElement', { static: true }) stripeBtnElement!: ElementRef;

  stripe: any;
  stripeElements: any;
  expressCheckout: any;
  config!: IPayConfig;

  loadTryCount = 0;

  ngOnChanges(changes: any) {
    if (!this.stripe) {
      this.load();
      return;
    }

    if (changes?.amount?.currentValue !== changes?.amount?.previousValue || changes?.currency?.currentValue !== changes?.currency?.previousValue) {
      this.updateElements();
    }
  }

  async load() {
    this.config = this.payments.getConfig();
    if (!this.config?.optionsResponse) return;
    await this.scriptLoader.newLoad('stripe');
    if (typeof Stripe === 'undefined') {
      if (this.loadTryCount > 5) return;
      setTimeout(() => {
        this.loadTryCount++;
        this.load();
      }, 200);
      return;
    }
    const stripeKey = this.config.optionsResponse.setting.stripe.key;
    this.stripe = await Stripe(stripeKey);
    if (!this.stripe) return;
    this.stripeElements = this.stripe.elements({
      mode: 'payment',
      currency: this.currency?.toLowerCase(),
      amount: this.amount * 100, // Amount in cents
    });
    this.expressCheckout = this.stripeElements.create('expressCheckout');
    this.expressCheckout.mount(this.stripeBtnElement.nativeElement);
    this.expressCheckout.on('ready', (e) => {
      this.availablePaymentMethods.emit(e.availablePaymentMethods);
    });
    this.expressCheckout.on('click', (e) => {
      this.payments.setConfig({ currency: 'USD' });
      this.onCheckoutClick.emit(e);
      e.resolve({});
    });
    this.expressCheckout.on('confirm', async (e) => {
      const interval = setInterval(() => {
        this.config = this.payments.getConfig();
        if (this.config?.sendResponse?.params?.client_secret) {
          const res = this.stripe?.confirmPayment({
            clientSecret: this.config?.sendResponse?.params?.client_secret,
            elements: this.stripeElements,
            confirmParams: {
              return_url: this.config?.sendPayoad?.return_url || ''
            }
          });
          clearInterval(interval);
        }
      }, 500);
    });
  }

  updateElements() {
    if (this.stripeElements) {
      this.stripeElements.update({
        amount: this.amount * 100,
        currency: this.currency?.toLowerCase()
      });
    }
  }
}
